import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { MARIGOLD, EERIE } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const TicketOutOfSyncTooltip = ({
  isOpenConversation
}) => {
  const title = isOpenConversation ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.alerts.status-syncing.close-conversation"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.alerts.status-syncing.open-conversation"
  });
  const infoType = isOpenConversation ? 'warning' : 'info';
  const color = isOpenConversation ? MARIGOLD : EERIE;
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "left",
    title: title,
    children: /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(UIIcon, {
        "data-test-id": "out-of-sync-icon",
        className: "m-right-2 m-top-2",
        name: infoType,
        size: "xxs",
        color: color
      })
    })
  });
};
TicketOutOfSyncTooltip.displayName = 'TicketOutOfSyncTooltip';
export default TicketOutOfSyncTooltip;